import React, { useState } from "react";
import _ from "underscore";
import {
  getDueDate,
  getScheduledAt,
  formattedDueDate,
  formatDate,
  toDate,
} from "../../lib/trays/TrayUtils";
import styled from "styled-components";
import SmallTray from "./SmallTray";
import classNames from "classnames";

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: -10px;
  align-items: flex-start;
`;

const Section = styled.div`
  // border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  background-color: white;
  margin-top: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;

  > .heading {
    h4 {
      text-transform: uppercase;
      margin: 0px;
      color: black;
      cursor: pointer;
      user-select: none;
      font-size: 13pt;
      span.tray-count {
        float: right;
        color: #bbb;
        margin-right: 15px;
      }
      &.contracted {
        color: #aaa;
      }
    }
  }
`;

const groupByDueDate = (theTrays) => _.groupBy(theTrays, (tray) => getDueDate(tray));
const groupByScheduled = (theTrays) => _.groupBy(theTrays, (tray) => getScheduledAt(tray));
export default function TraysSection({
  trays,
  title,
  description,
  activeTray,
  showTechniqueNames,
  setActiveTray,
  selectedTrayIds,
  selectTray,
  displayOptions,
  selectTrays,
  unSelectTrays,
  hide = false,
}) {
  const [selected, setSelected] = useState(false);
  const [hidden, setHidden] = useState(hide);

  const toggleSelected = () => {
    if (selected) {
      unSelectTrays(trays.map((t) => t.id));
    } else {
      selectTrays(trays.map((t) => t.id));
    }
    setSelected(!selected);
  };

  const renderHeader = () => {
    return (
      <div className="heading">
        <h4 className={classNames({ contracted: hidden })}>
          {!trays && (
            <span>
              <i className="fa fa-spinner fa-spin" />
              &nbsp;&nbsp;
            </span>
          )}
          {trays &&
            trays.length > 0 && (
              <div className="pull-right">
                <input type="checkbox" checked={selected} onChange={toggleSelected} />
              </div>
            )}
          <span onClick={() => setHidden(!hidden)}>{title}</span>
          {hidden && <span> [hidden]</span>}
          {trays && <span className="tray-count">{trays.length} trays</span>}
        </h4>
        {/* {description && <div className="subtitle">{description}</div>} */}
      </div>
    );
  };

  if (!trays) {
    return <Section style={{ marginBottom: 0 }}>{renderHeader()}</Section>;
  }

  if (hidden) {
    return <Section style={{ marginBottom: 0 }}>{renderHeader()}</Section>;
  }

  const grouped =
    displayOptions.groupBy == "due_date" ? groupByDueDate(trays) : groupByScheduled(trays);
  const dateKeys = _.sortBy(Object.keys(grouped), (key) => toDate(key));

  return (
    <Section style={{ marginBottom: trays.length > 0 ? 0 : 0 }}>
      {renderHeader()}
      {dateKeys.map((key) => {
        const theTrays = grouped[key];
        const date = formatDate(key, "DD MMM");
        return (
          <div key={key} style={{ display: "flex", marginTop: 10 }}>
            {date ? (
              <h4
                style={{
                  marginTop: 10,
                  color: "#888",
                  fontSize: "11pt",
                  marginBottom: 0,
                  marginRight: 30,
                  marginTop: 5,
                  whiteSpace: "nowrap",
                }}
              >
                {displayOptions.groupBy == "due_date" && <span>Due </span>}
                {displayOptions.groupBy == "scheduled_date" && <span>Scheduled </span>}
                {date}:
              </h4>
            ) : (
              <br />
            )}
            <Container style={{ flexGrow: 1 }}>
              {theTrays.map((t) => (
                <SmallTray
                  key={t.id}
                  tray={t}
                  active={activeTray && t.id === activeTray.id}
                  showTechniques={showTechniqueNames}
                  medium={showTechniqueNames}
                  handleActivateTray={() =>
                    activeTray && activeTray.id === t.id
                      ? setActiveTray(null)
                      : setActiveTray(t)
                  }
                  handleSelectTray={() => selectTray(t.id)}
                  selected={selectedTrayIds.includes(t.id)}
                  displayOptions={displayOptions}
                />
              ))}
            </Container>
          </div>
        );
      })}
    </Section>
  );
}
